export default __webpack_public_path__ + "static/media/thor-horizontal.f91857b8.png";